import {FocusTrap} from './focus-trap';

const initClearFilters = () => {
  const clearFilters = document.querySelector( '.clear-filters' );

  if (!clearFilters) {
    return;
  }

  clearFilters.addEventListener( 'click', event => {
    event.preventDefault();

    const searchForm = document.querySelector( '.search-results__filter' );

    if (!searchForm) {
      return;
    }

    const searchInput = searchForm.querySelectorAll( 'input[type="text"]' );
    const searchCheckboxes = searchForm.querySelectorAll( 'input[type="checkbox"]' );

    if (searchInput) {
      [...searchInput].forEach( input => {
        input.value = '';
      } );
    }

    if (searchCheckboxes) {
      [...searchCheckboxes].forEach( checkbox => {
        checkbox.checked = false;
      } );
    }
  } );
}

const initFilterToggle = () => {
  const filterToggle = document.querySelectorAll( '[data-toggle-search-filter]' );

  if (!filterToggle) {
    return;
  }

  [...filterToggle].forEach( toggle => {
    toggle.addEventListener( 'click', event => {
      event.preventDefault();

      const filter = document.querySelector( '.search-results__filter' );

      if (!filter) {
        return;
      }

      const focusTrap = new FocusTrap( filter );
      const closeButtonInFilter = filter.querySelector( '.close-filter' );
      const openFilterInHero = document.querySelector( '.open-filter' );

      filter.classList.toggle( 'open' );
      document.body.classList.toggle( 'overflow-hidden' );
      if (filter.classList.contains( 'open' )) {
        setTimeout( () => {
          closeButtonInFilter.focus();
        }, 100 );
        focusTrap.enable();
        openFilterInHero.setAttribute( 'aria-expanded', 'true' );

        document.addEventListener( 'keydown', event => {
          if (event.key === 'Escape') {
            filter.classList.remove( 'open' );
            focusTrap.disable();
            openFilterInHero.setAttribute( 'aria-expanded', 'false' );
            openFilterInHero.focus();
          }
        } );
      } else {
        setTimeout( () => {
          openFilterInHero.focus();
        }, 100 );
        focusTrap.disable();
        openFilterInHero.setAttribute( 'aria-expanded', 'false' );
      }
    } );
  } );
}

const search = () => {
  initClearFilters();
  initFilterToggle();
}

export default search;
